module.exports = __webpack_public_path__ + "static/media/oil-temp.0d172c1e.svg";